/**
 * Starts a download of the file at `url` (e.g. a rendered PDF), opening it in a new tab when the
 * browser can't download it directly. Does nothing for an empty url.
 */
export const downloadFromUrl = (url) => {
	if (!url) return;
	const a = document.createElement("a");
	a.href = url;
	a.target = "_blank";
	a.download = "";
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};

/**
 * Saves a file already in the browser (e.g. from makeAuthenticatedRequest with responseType: "blob")
 * under `fileName`. Does nothing without a blob.
 */
export const downloadBlob = (blob, fileName) => {
	if (!blob) return;
	const blobUrl = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = blobUrl;
	a.download = fileName || "download";
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	// Let the browser start the download before the object URL is released.
	setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
};
